import { t, type Idioma } from '@matias-asset-os/i18n';
import { Icono } from '../componentes/Iconos.js';

/**
 * CONTACTO DEL PROPIETARIO
 *
 * La maqueta dibujaba aquí un formulario con botón «Enviar» que mandaba un
 * correo al administrador. No está construido, y el motivo es deliberado: hoy
 * no hay ningún servicio de correo configurado, así que ese botón no enviaría
 * nada. Un formulario que traga mensajes en silencio es peor que no tenerlo:
 * el propietario se queda esperando una respuesta que nadie ha recibido.
 *
 * Mientras tanto esta página hace lo que sí funciona de verdad: explica los dos
 * canales que el equipo lee —reportar una incidencia y escribir en su hilo— y
 * responde las preguntas que se repiten.
 */

const PREGUNTAS = [
  'semaforo',
  'idiomaClave',
  'reportar',
  'informe',
] as const;

export function Contacto({ idioma }: { idioma: Idioma }) {
  return (
    <main className="portal">
      <header className="portal-cabeza">
        <h1>{t(idioma, 'portal.contacto')}</h1>
        <p className="suave">{t(idioma, 'contacto.intro')}</p>
      </header>

      <section className="tarjeta">
        <h2>{t(idioma, 'contacto.comoEscribir')}</h2>
        <div className="lista">
          <div className="fila">
            <span aria-hidden="true">＋</span>
            <span className="crecer">
              <b>{t(idioma, 'portal.reportar')}</b>
              <small>{t(idioma, 'contacto.reportarPie')}</small>
            </span>
          </div>
          <div className="fila">
            <Icono nombre="comentario" />
            <span className="crecer">
              <b>{t(idioma, 'contacto.responderHilo')}</b>
              <small>{t(idioma, 'contacto.responderHiloPie')}</small>
            </span>
          </div>
        </div>
      </section>

      <section className="tarjeta">
        <h2>{t(idioma, 'contacto.faq')}</h2>
        {PREGUNTAS.map((p) => (
          <details key={p} className="plegable">
            <summary>{t(idioma, `contacto.p.${p}`)}</summary>
            <div className="cuerpo">
              <p className="prosa">{t(idioma, `contacto.r.${p}`)}</p>
            </div>
          </details>
        ))}
      </section>
    </main>
  );
}
